import {
  subscribeCredentialModerateCount,
  subscribeEventModerateCount,
  subscribeOnline,
} from 'actions/entities/userActions';
import { subscribeActivityLogChanges } from 'actions/entities/taskActions';
import { subscribeNewFeed } from 'actions/ui/notificationDrawerActions';
import { subscribeTimerStarted, subscribeTimerStopped } from 'actions/ui/timerActions';
import { call, put } from 'redux-saga/effects';
import SocketService from 'services/SocketService';

const socketInstance = SocketService.Instance;

export default function* initializeSocketSaga(userId, companyId) {
  yield call(socketInstance.reconnect, userId, companyId);
  yield put(subscribeOnline());
  yield put(subscribeNewFeed());
  yield put(subscribeTimerStarted());
  yield put(subscribeTimerStopped());
  yield put(subscribeCredentialModerateCount());
  yield put(subscribeEventModerateCount());
  yield put(subscribeActivityLogChanges());
}
